import styles from './drawer.module.scss';
import MatrerialDrawer from '@mui/material/Drawer';

/* eslint-disable-next-line */
export interface DrawerProps {
  anchor?: 'bottom' | 'left' | 'right' | 'top',
  children?: any,
  // classes?: object,
  elevation?: number,
  hideBackdrop?: boolean,
  // ModalProps?: object,
  onClose?: (event: CloseEvent) => void,
  open?: boolean,
  // PaperProps?: object,
  // SlideProps?: object,
  // sx?: any,
  // transitionDuration?: number | { appear?: number, enter?: number, exit?: number },
  variant?: 'permanent' | 'persistent' | 'temporary'
}

export function Drawer(props: DrawerProps) {
  return (
    <MatrerialDrawer
      anchor={props.anchor}
      open={props.open}
      onClose={props.onClose}
      elevation={props.elevation}
      hideBackdrop={props.hideBackdrop}
      variant={props.variant}>
      {props.children}
    </MatrerialDrawer>
  );
}

export default Drawer;